module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/halloween_img_tiktok.b831a48b.png";